<!--
 * @Author: your name
 * @Date: 2022-01-12 14:51:08
 * @LastEditTime: 2023-03-27 11:44:28
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/changma_cx5/index.vue
-->
<template>
  <div id="main" :class="{ bg2: type == 'test' }">
    <div class="banner">
      <img
        src="https://source.qunarzz.com/site/images/wns/20230320-shijianchen-gameforpeace-1.jpg"
        alt=""
      />
    </div>
    <div class="video">
      <!-- <div class="video-tp"></div> -->
      <div class="video-cont">
        <video-comp
          poster="https://source.qunarzz.com/site/images/wns/20230119-shijianchen-poster.jpeg"
          :src="'https://source.qunarzz.com/site/images/wns/20230112-shijianchen-video1.mp4'"
        ></video-comp>
      </div>
    </div>
    <div class="start">
      <a class="startBtn" @click="start"></a>
      <span @click="ruleDialog" class="ruleBtn"></span>
      <div class="tipBox">
        <img
          v-if="!hasLottery"
          @click="peacePerson"
          class="tip2"
          src="https://source.qunarzz.com/site/images/wns/20230320-shijianchen-game-card-1.png"
          alt=""
        />
        <img
          v-if="hasLottery"
          @click="peacePerson2"
          class="tip2"
          src="https://source.qunarzz.com/site/images/wns/20230320-shijianchen-game-card-2.png"
          alt=""
        />
      </div>
    </div>
    <div class="imgList">
      <mt-swipe :auto="0" class="swiper" ref="swipeWrapper">
        <mt-swipe-item v-for="(item, index) in imgList" :key="index">
          <img :src="item" alt="" />
        </mt-swipe-item>
      </mt-swipe>
    </div>
  </div>
</template>
<script>
import square from '@/components/zhuanpan/index2.vue';
import appoint from './components/appoint.vue';
import gotomini2 from './components/gotomini2.vue';
import videoComp from './components/video.vue';
import giftDialog from './components/dialog/gift/gift';
import loginDialog from '@/components/login/index';
import ruleDialog from './components/dialog/rule/index';
import maidian from '@/utils/maidian'
export default {
  components: {
    square,
    appoint,
    videoComp,
    gotomini2,
  },
  data() {
    return {
      bg: '',
      type: '',
      hasLottery: false,
      imgList: [
        'https://source.qunarzz.com/site/images/wns/20230321-shijianchen-img001.jpg',
        'https://source.qunarzz.com/site/images/wns/20230321-shijianchen-img-2.png',
        'https://source.qunarzz.com/site/images/wns/20230321-shijianchen-img-3.png',
        'https://source.qunarzz.com/site/images/wns/20230321-shijianchen-img-4.png',
      ],
    };
  },
  methods: {
    ruleDialog,
    start() {
      maidian.eventBind('peaceAdd')
      this.$http({
        url: '/commonly/peaceAdd',
        type: 'get',
        data: {},
        config: { formType: true },
        success: (res) => {
          window.location.href =
            'https://gp.qq.com/zlkdatasys/mct/proj_118/download.shtml?media=10132010&back=cururl';
        },
      });
    },
    peacePerson2() {
      this.getMyPrize(true);
    },
    commonAjax(config) {
      this.$axios[config.method || 'post'](config.url, config.data || {}).then(
        (res) => {
          if (res.code == 200) {
            config.success && config.success(res.data);
          } else if (res.code == 400) {
            if (config.hide == 'login') {
              return;
            }
            loginDialog({
              callback: () => {
                this.commonAjax(config);
              },
            });
          } else {
            !config.hideError &&
              this.$dialog.alert({
                message: res.message,
              });
          }
        },
      );
    },
    getMyPrize(showDialog) {
      this.commonAjax({
        url: '/commonly/getMyPrzie',
        method: 'get',
        hide: true,
        success: (res) => {
          let hasLottery = false;
          let data = {};
          res.forEach((item) => {
            if (item.prizeCode != 'THANKS') {
              data = item;
              hasLottery = true;
            }
          });
          this.hasLottery = hasLottery;
          if (!data.prizeCode) return;
          if(showDialog && data.received){
            this.$dialog.alert({
              message:'已提交'
            })
            return;
          }
          if (showDialog && hasLottery) {
            giftDialog({
              giftTip: data.prizeCode,
              winRecordId: data.id,
            });
          }
        },
      });
    },
    peacePerson() {
      this.$http({
        url: '/commonly/peacePerson',
        type: 'get',
        data: {},
        config: { formType: true },
        success: (res) => {
          if (res.data) {
            // window.location.href =
            //   'https://m.flight.qunar.com/shark/active/e38223eb66a94ef580a0375f4f11f09e?bdsource=huawei';
            this.commonAjax({
              url: '/commonly/v2/lottery',
              method: 'post',
              success: (data) => {
                giftDialog({
                  giftTip: data.code,
                  winRecordId: data.winRecordId,
                });
                this.getMyPrize();
              },
            });
          } else {
            this.$dialog.alert({
              message: '启动游戏后才可以领取代金券哦',
            });
          }
        },
      });
    },
  },
  mounted() {
    //helpDialog({});
    // this.commonGetChannelNum();
    // this.autoShowDetail();
    // uploadDialog({});
    // giftDialog({
    //   giftTip: 'THANKS',
    // });
    this.getMyPrize();
    if (this.$route.query.type) {
      this.type = 'test';
    }
    if (new Date().getTime() > new Date('2023/01/17 00:00:00').getTime()) {
      this.type = 'test';
    }
  },
};
</script>
<style lang='less' scoped='true'>
@font-face {
  font-family: 'MazdaTypeRegular';
  src: url('./MazdaTypeRegular.otf');
}
@font-face {
  font-family: 'NotoSansCJKscRegular';
  src: url('https://source.qunarzz.com/site/images/wns/NotoSansCJKsc-Regular.otf');
}
#main {
  min-height: 100vh;
}
.banner {
  height: 286px;
}
.ruleBtn {
  position: absolute;
  right: 24px;
  top: 29px;
  width: 60px;
  height: 24px;
}
.tipBox{
  position: absolute;
  left:0;
  bottom: 0;
  width: 100%;
}
#main.bg2 {
  // background: url(https://source.qunarzz.com/site/images/wns/20230112-shijianchen-bg.jpg)
  //   no-repeat;
  // background-size: 100% auto;
  min-height: 100vh;
  background-color: #252f56;
  .banner {
    height: 314px;
  }
}
.video {
  background: url(https://source.qunarzz.com/site/images/wns/20230320-shijianchen-gameforpeace-2.jpg)
    no-repeat;
  background-size: 100% auto;
  width: 100%;
  position: relative;
  height: 398px;
}
.video-cont {
  // background: url(https://source.qunarzz.com/site/images/wns/20230112-shijianchen-bgCont.jpg);
  // background-size: 100% auto;
  padding-top: 83px;
  box-sizing: border-box;
}
.video-tp {
  background: url(https://source.qunarzz.com/site/images/wns/20230112-shijianchen-video.png)
    no-repeat;
  background-size: 100% auto;
  height: 74px;
}
.video-btm {
  background: url(https://source.qunarzz.com/site/images/wns/20230112-shijianchen-video.png)
    no-repeat;
  background-size: 100% auto;
  background-position-y: -267px;
  height: 35px;
}
.start {
  background: url(https://source.qunarzz.com/site/images/wns/20230320-shijianchen-gameforpeace-3.jpg)
    no-repeat;
  background-size: 100% auto;
  width: 100%;
  height: 350px;
  position: relative;
}
.tip2 {
  width: 358px;
  margin: 8px auto;
}
.imgList {
  background: url(https://source.qunarzz.com/site/images/wns/20230320-shijianchen-gameforpeace-4.jpg)
    no-repeat;
  background-size: 100% auto;
  width: 100%;
  height: 390px;
  position: relative;
  margin: 0 auto;
}
.swiper {
  width: 320px;
  margin: 0 auto;
  position: absolute;
  top: 111px;
  height: 216px;
  left:50%;
  transform: translateX(-50%);
  /deep/ .mint-swipe-indicators {
    bottom: 0px;
  }
  /deep/ .mint-swipe-indicator {
    background: #4f67bf;
    opacity: 1;
  }
  /deep/ .mint-swipe-indicator.is-active {
    opacity: 1;
    background: linear-gradient(116deg, #7fd7fe 0%, #8984e4 100%);
  }
}
.startBtn {
  width: 185px;
  position: relative;
  top: 97px;
  height: 39px;
  display: block;
  left: 96px;
}
</style>